import { BrandMark } from "./BrandMark.tsx";
import { Glass } from "./Glass.tsx";
import { SkyCanvas } from "./SkyCanvas.tsx";
import {
  GITHUB_REPO_URL,
  QQ_CHANNEL_URL,
  SITE_NAME,
  SITE_TAGLINE,
  SPONSOR_URL,
} from "../lib/site.ts";

const footLink = "text-muted-foreground transition-colors duration-150 hover:text-foreground";

export function SiteFooter() {
  return (
    <footer className="relative mt-20 px-3 pb-3 sm:mt-28 sm:px-4 sm:pb-4">
      <div className="relative isolate mx-auto w-full max-w-6xl">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 -z-10 overflow-hidden rounded-2xl"
          style={{
            maskImage: "linear-gradient(to top, black, transparent 80%)",
            WebkitMaskImage: "linear-gradient(to top, black, transparent 80%)",
          }}
        >
          <SkyCanvas mode="mist" className="h-full w-full -scale-y-100" />
        </div>
        <Glass className="isolate relative rounded-2xl border border-border/50 shadow-lg shadow-black/10">
          <div className="flex flex-col gap-10 px-6 py-12 sm:flex-row sm:items-start sm:justify-between sm:gap-12 sm:py-14">
            <div className="max-w-xs">
              <div className="flex items-center gap-2.5">
                <BrandMark className="size-7" />
                <span className="text-[15px] font-semibold tracking-tight">{SITE_NAME}</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{SITE_TAGLINE}</p>
            </div>
            <div className="grid grid-cols-2 gap-x-10 gap-y-8 text-sm md:grid-cols-3 md:gap-x-12">
              <div className="flex flex-col gap-2.5">
                <span className="text-sm font-semibold text-foreground">产品</span>
                <a href="/#features" className={footLink}>
                  功能
                </a>
                <a href="/#pricing" className={footLink}>
                  价格
                </a>
                <a href="/#download" className={footLink}>
                  下载
                </a>
                <a href="/#faq" className={footLink}>
                  常见问题
                </a>
              </div>
              <div className="flex flex-col gap-2.5">
                <span className="text-sm font-semibold text-foreground">资源</span>
                <a
                  href={GITHUB_REPO_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={footLink}
                >
                  GitHub 源码
                </a>
                <a href="/purchase/" className={footLink}>
                  购买授权
                </a>
                <a
                  href={SPONSOR_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={footLink}
                >
                  赞助支持
                </a>
              </div>
              <div className="flex flex-col gap-2.5">
                <span className="text-sm font-semibold text-foreground">支持</span>
                <a
                  href={QQ_CHANNEL_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={footLink}
                >
                  QQ 频道
                </a>
                <a
                  href={`${GITHUB_REPO_URL}/blob/master/LICENSE`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={footLink}
                >
                  Apache-2.0 许可
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-border/60">
            <div className="flex w-full flex-col gap-2 px-6 py-4 text-sm text-muted-foreground/60 sm:flex-row sm:items-center sm:justify-between sm:py-5">
              <span>© {SITE_NAME} · wu-clan 出品</span>
              <span className="inline-flex items-center gap-1.5">Windows · macOS · Linux</span>
            </div>
          </div>
        </Glass>
      </div>
    </footer>
  );
}
